module.exports = __webpack_public_path__ + "static/media/user-white.65f94e21.svg";